export const TIPOS = Object.freeze([
    { value: 'venta', label: 'Venta' },
    { value: 'alquiler_administracion', label: 'Alquiler con Administración' },
    { value: 'alquiler_corretaje', label: 'Alquiler por Corretaje' },
]);

export const ESTADOS = Object.freeze([
    { value: 'borrador', label: 'Borrador' },
    { value: 'confirmada', label: 'Confirmada' },
    { value: 'cancelada', label: 'Cancelada' },
]);

export const VIGENCIAS = Object.freeze([
    { value: 'vigente', label: 'Vigente' },
    { value: 'por_vencer', label: 'Por vencer (≤ 60 días)' },
    { value: 'vencido', label: 'Vencido' },
]);

export const ORDENES = Object.freeze([
    { value: 'recientes', label: 'Más recientes' },
    { value: 'fecha_cierre', label: 'Fecha de cierre' },
    { value: 'fecha_fin', label: 'Fecha de fin' },
    { value: 'valor', label: 'Valor' },
    { value: 'comision', label: 'Comisión' },
]);

const ACCIONES_HISTORIAL = {
    creado: 'Creado',
    borrador_actualizado: 'Borrador actualizado',
    propietario_vinculado: 'Propietario vinculado al inmueble',
    borrador_eliminado: 'Borrador eliminado',
    confirmado: 'Confirmado',
    despublicacion_portales_encolada: 'Despublicación en portales encolada',
    despublicacion_portales_fallida: 'Falló la despublicación en portales',
    cancelado: 'Cancelado',
    documento_subido: 'Documento subido',
    documento_descargado: 'Documento descargado',
    documento_eliminado: 'Documento eliminado',
};

// Rótulos de los campos de resumen_negocio, negocio.datos y negocio.calculos.
// Lo que no esté aquí se muestra con el nombre del campo legible.
const ROTULOS = {
    fecha_cierre: 'Fecha de cierre',
    fecha_inicio: 'Fecha de inicio',
    fecha_fin: 'Fecha de fin',
    fecha_fin_manual: 'Fecha de fin manual',
    fecha_fin_calculada: 'Fecha de fin calculada',
    fecha_entrega: 'Fecha de entrega',
    fecha_firma: 'Fecha de firma',
    valor_principal: 'Valor principal',
    comision_total: 'Comisión total (con IVA)',
    comision_subtotal: 'Comisión antes de IVA',
    comision_iva: 'IVA de la comisión',
    comision_modo: 'Modo de comisión',
    comision_porcentaje: 'Comisión %',
    comision_porcentaje_efectivo: 'Comisión % efectiva',
    comision_valor: 'Valor de la comisión',
    tipo_venta: 'Tipo de venta',
    tipo_contrato: 'Tipo de contrato',
    forma_pago: 'Forma de pago',
    banco_id: 'Banco',
    pago_agentes: 'Pago a agentes',
    aplica_iva: 'Aplica IVA',
    iva_porcentaje: 'IVA %',
    canon: 'Canon',
    paga_ph: 'Paga PH',
    valor_ph: 'Valor PH',
    ph_responsable: 'Responsable del PH',
    ph_a_cargo_propietario: 'PH a cargo del propietario',
    duracion_meses: 'Duración (meses)',
    admin_porcentaje: 'Administración %',
    admin_base: 'Base de la administración',
    admin_base_valor: 'Valor base de la administración',
    admin_iva: 'IVA de la administración',
    admin_neto: 'Administración neta',
    admin_total: 'Administración total',
    honorarios_mensuales: 'Honorarios mensuales',
    hubo_colocacion: 'Hubo colocación',
    colocacion_modo: 'Modo de colocación',
    colocacion_porcentaje: 'Colocación %',
    colocacion_canones: 'Colocación (cánones)',
    colocacion_valor: 'Valor de colocación',
    colocacion_aplica_iva: 'Colocación con IVA',
    colocacion_subtotal: 'Colocación antes de IVA',
    colocacion_iva: 'IVA de la colocación',
    colocacion_total: 'Colocación total',
    total_mensual_arrendatario: 'Total mensual arrendatario',
    ingreso_recurrente_mensual: 'Ingreso recurrente mensual',
    ingreso_inicial: 'Ingreso inicial',
    ingreso_inicial_antes_iva: 'Ingreso inicial antes de IVA',
    ingreso_antes_iva: 'Ingreso antes de IVA',
    total_facturado: 'Total facturado',
    tiene_aseguradora: 'Tiene aseguradora',
    aseguradora: 'Aseguradora',
    aseguradora_otra: 'Otra aseguradora',
    poliza_numero: 'Número de póliza',
    poliza_inicio: 'Inicio de la póliza',
    poliza_fin: 'Fin de la póliza',
    poliza_pagador: 'Pagador de la póliza',
    poliza_valor_asegurado: 'Valor asegurado',
    tiene_garantia: 'Tiene garantía',
    garantia_tipo: 'Tipo de garantía',
    garantia_valor: 'Valor de la garantía',
    garantia_observaciones: 'Observaciones de la garantía',
    servicios: 'Servicios',
    internet_otros: 'Internet / otros',
    pagador_comision: 'Pagador de la comisión',
    pagador_comision_nombre: 'Pagador de la comisión',
    aporte_propietario: 'Aporte del propietario',
    aporte_arrendatario: 'Aporte del arrendatario',
    diferencia_aportes: 'Diferencia de aportes',
    base_reparto: 'Base del reparto (antes de IVA)',
    porcentaje_vendedor: 'Lado vendedor %',
    pago_vendedor: 'Pago lado vendedor',
    porcentaje_comprador: 'Lado comprador %',
    pago_comprador: 'Pago lado comprador',
    porcentaje_inmobiliaria: 'Inmobiliaria %',
    participacion_inmobiliaria: 'Participación de la inmobiliaria',
    observaciones: 'Observaciones',
    vigencia: 'Vigencia',
};

// Números que no son dinero ni porcentaje
const NUMEROS_SIMPLES = ['duracion_meses', 'colocacion_canones', 'banco_id'];

// Texto libre que puede venir solo con dígitos (pólizas, cuentas de servicios)
const TEXTOS = [
    'poliza_numero', 'energia', 'acueducto', 'gas', 'internet_otros',
    'aseguradora_otra', 'garantia_observaciones', 'observaciones',
];

// Valores de catálogo que llegan como código
const VALORES = {
    vigente: 'Vigente',
    por_vencer: 'Por vencer',
    vencido: 'Vencido',
    arrendatario: 'Arrendatario',
    propietario: 'Propietario',
    incluida_canon: 'Incluida en el canon',
    ambos: 'Ambos',
    residencial: 'Residencial',
    comercial: 'Comercial',
    abierto: 'Abierto',
    exclusivo: 'Exclusivo',
    contado: 'Contado',
    credito: 'Crédito',
    completo: 'Completo',
    periodico: 'Periódico',
    porcentaje: 'Porcentaje',
    valor_fijo: 'Valor fijo',
    canones: 'Cánones',
    canones_1: '1 canon',
    canones_2: '2 cánones',
    personalizado: 'Personalizado',
    canon_ph: 'Canon + PH',
    otro: 'Otro',
    si: 'Sí',
    no: 'No',
    no_aplica: 'No aplica',
};

export const rotulo = (campo) => {
    if (ROTULOS[campo]) return ROTULOS[campo];
    const texto = String(campo).replace(/_/g, ' ');
    return texto.charAt(0).toUpperCase() + texto.slice(1);
};

export const formatMonto = (valor) => {
    if (valor === null || valor === undefined || valor === '') return '—';
    const numero = Number(valor);
    if (isNaN(numero)) return valor;
    return `$ ${numero.toLocaleString('es-CO', { maximumFractionDigits: 2 })}`;
};

export const formatNumero = (valor) => {
    if (valor === null || valor === undefined || valor === '') return '—';
    const numero = Number(valor);
    return isNaN(numero) ? valor : numero.toLocaleString('es-CO', { maximumFractionDigits: 2 });
};

export const formatFecha = (valor) => {
    if (!valor) return '—';
    // Solo fecha (YYYY-MM-DD): sin pasar por Date para no correr el día por la zona horaria
    const soloFecha = /^(\d{4})-(\d{2})-(\d{2})$/.exec(valor);
    if (soloFecha) {
        const [, y, m, d] = soloFecha;
        return new Date(Number(y), Number(m) - 1, Number(d)).toLocaleDateString('es-CO', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
        });
    }
    const fecha = new Date(String(valor).replace(' ', 'T'));
    if (isNaN(fecha.getTime())) return valor;
    return fecha.toLocaleString('es-CO', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });
};

// Formatea un valor de negocio según el nombre del campo
export const formatCampo = (campo, valor) => {
    if (valor === null || valor === undefined || valor === '') return '—';
    if (typeof valor === 'boolean') return valor ? 'Sí' : 'No';
    if (TEXTOS.includes(campo)) return String(valor);
    if (campo.startsWith('fecha') || campo === 'poliza_inicio' || campo === 'poliza_fin') {
        return formatFecha(valor);
    }
    if (typeof valor === 'number' || (typeof valor === 'string' && valor.trim() !== '' && !isNaN(Number(valor)))) {
        if (NUMEROS_SIMPLES.includes(campo)) return formatNumero(valor);
        if (campo.includes('porcentaje')) return `${formatNumero(valor)} %`;
        return formatMonto(valor);
    }
    if (typeof valor === 'string') return VALORES[valor] || valor;
    return JSON.stringify(valor);
};

export const accionHistorial = (accion) => ACCIONES_HISTORIAL[accion] || rotulo(accion || '');

export const claseEstado = (estado) => {
    switch (estado) {
        case 'confirmada':
            return 'bg-success';
        case 'cancelada':
            return 'bg-danger';
        default:
            return 'bg-secondary';
    }
};

export const claseTipo = (tipo) => {
    switch (tipo) {
        case 'venta':
            return 'tipo-venta';
        case 'alquiler_administracion':
            return 'tipo-administracion';
        default:
            return 'tipo-corretaje';
    }
};

export const claseVigencia = (vigencia) => {
    switch (vigencia) {
        case 'vencido':
            return 'bg-danger';
        case 'por_vencer':
            return 'bg-warning';
        default:
            return 'bg-success';
    }
};

export const formatTamano = (bytes) => {
    if (!bytes && bytes !== 0) return '—';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const nombreContacto = (contacto) => contacto?.nombre || '—';
